import PropTypes from "prop-types";

import { t } from "../../services";
import { strCode } from "../../consts";

import { DateInput, FlexContainers } from "../../components";
import { DateRangeInputWrapper } from "./styled";

const DateRangeInput = ({
  fromDate,
  fromTitle,
  setFromDate = () => {},
  toDate,
  toTitle,
  setToDate = () => {},
  minDate,
  maxDate,
  noTime,
  errors,
  disabled,
  autoComplete
}) => {
  return (
    <DateRangeInputWrapper Container={FlexContainers.FlexRowStart} gap={16}>
      <DateInput
        id={"start"}
        title={fromTitle ? t(fromTitle) : t(strCode.FROM_TITLE)}
        value={fromDate}
        setValue={setFromDate}
        maxDate={toDate || maxDate}
        minDate={minDate}
        startDate={fromDate}
        endDate={toDate}
        disabled={disabled}
        hasError={errors?.start}
        autoComplete={autoComplete}
      />

      <DateInput
        id={"end"}
        title={toTitle ? t(toTitle) : t(strCode.UNTIL_TITLE)}
        value={toDate}
        setValue={setToDate}
        minDate={fromDate || minDate}
        maxDate={maxDate}
        startDate={fromDate}
        endDate={toDate}
        disabled={disabled}
        hasError={errors?.end}
        noTime={noTime}
        autoComplete={autoComplete}
      />
    </DateRangeInputWrapper>
  );
};

DateRangeInput.propTypes = {
  fromDate: PropTypes.instanceOf(Date),
  fromTitle: PropTypes.string,
  setFromDate: PropTypes.func.isRequired,
  toDate: PropTypes.instanceOf(Date),
  toTitle: PropTypes.string,
  setToDate: PropTypes.func.isRequired,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  noTime: PropTypes.bool,
  errors: PropTypes.shape({ start: PropTypes.bool, end: PropTypes.bool }),
  disabled: PropTypes.bool,
  autoComplete: PropTypes.bool
};

export default DateRangeInput;
